import { useContext } from 'react'
import Cookies from 'js-cookie'
import { SetPlayerNameComp } from './SetPlayerNameCompF.jsx'
import { GameContext } from '../GameContextF.jsx'
import { RecentGames } from './RecentGamesF.jsx'
import { useRouter } from 'next/router'
import { FetchGameState } from '../GameCompsF.jsx'
import { ChooseKickPlayer } from './ChooseKickPlayer.jsx'
import { Container, Heading, Stack, Text } from '@chakra-ui/react'
import { WrapRewindGame } from '../TelDrawGame/OldGameViewer/WrapRewindGameF.jsx'
import { Body100PctCss } from '../../../componentsF/PageTemplateF.jsx'
import { useNow } from '../../../componentsF/hooksF/useNowF.jsx'
import { LuxDt } from '../../../sharedF/timeF/Date1TimeF.mts'
const ExistingGameComp = ({children}) => {
  const {playerAlias, isKickingPlayer} = useContext(GameContext)

  if (!playerAlias) return <RecentGames>
    <SetPlayerNameComp {...{}}/>
  </RecentGames>

  if (isKickingPlayer) return <ChooseKickPlayer />

  return <div data-testid="game-area">
    {children}
  </div>
}

export const useGameRoom = () => {
  const {query: {gameRoom}} = useRouter()
  return {gameRoom}
}

export const WrapFetchGameState = ({children}) => {
  const {gameRoom} = useGameRoom()
  
  // Set cookie for ingress-nginx consistent hash routing
  // Must be set synchronously BEFORE FetchGameState renders to ensure
  // the first GQL request includes the cookie for consistent pod routing
  if (gameRoom && typeof window !== 'undefined') {
    Cookies.set('gameShardCook', gameRoom, { expires: 365, sameSite: 'strict' })
  }
  
  if (!gameRoom) return null
  return <FetchGameState {...{}}>
    {children}
  </FetchGameState>
}

export const GamePgCont = ({children, justifyContent='center'}) => {
  return <>
    <Body100PctCss />
    <Container {...{
      py: 10, minH: '100%', as: Stack, spacing: 0, justifyContent, textAlign: 'center', children,
      maxW: 'auto',
    }} />
  </>
}

export const GameContentCont = ({children}) => {
  return <Container {...{px: 0, children}} />
}

const GameRescheduled = () => {
  const {now} = useNow()

  if (true || now >= LuxDt.fromISO('2025-06-19T09:08:34.123+06:00')) return
  return <Heading>Rescheduled to Thur!</Heading>
}

export const GenericGamePage = ({children}) => {
  return <GamePgCont {...{justifyContent: 'space-evenly'}}>
    <GameRescheduled />
    <WrapFetchGameState>
      <WrapRewindGame>
        <ExistingGameComp {...{children}} />
      </WrapRewindGame>
    </WrapFetchGameState>
  </GamePgCont>
}